export default {
  en: {
    title: "Monitor",
    skill_tab: "Queues",
    call_tab: "Calls",
    agent_tab: "Agents",
    skill_select_title: "Queue Select",
    monitor_btn_start: "start",
    monitor_btn_monitor: "monitoring...",
    details_list: "list",
    details_view: "View",
    current_calls: "Ongoing Calls",
    current_agents: "Agents",
    current_waiting: "Queue Calls",
    dialog_processing: "Monitor Processing......",
    max_waiting_time: "Max Waiting Time",
    resting_agents: "Resting",
    busy_agents: "Not Ready",
    no_calls: "No calls in progress",
    all_skills: "All",
    main_skills: {
      title: "Queues Calls/Agents stacked",
      incoming_waiting: "Incoming Waiting",
      incoming_talking: "Incoming Talking",
      incoming_total: "Incoming Total",
      outgoing_talking: "Outgoing Talking",
      agents_offline: "Offline Agents",
      agents_busy: "Busy Agents",
      agents_rest: "Rest Agents",
      agents_idle: "Idle Agents",
      agents_talking: "Talking Agents",
      agents_total: "Total Agents",
      agents_common: "Agents",
      agents_not_ready: "Not Ready",
      skill: "Queue",
    },
    calls_chart: {
      title: "Queues Calls",
      calls_total: "Incoming Total",
      incoming_waiting: "Incoming Waiting",
      incoming_talking: "Incoming Talking",
      outgoing_talking: "Outgoing Talking",
    },
    agents_chart: {
      title: "Queues Agents",
      agents_total: "Total Agents",
      agents_offline: "Offline",
      agents_busy: "Not Ready",
      agents_rest: "Resting",
      agents_idle: "Idle",
      agents_talking: "Talking",
      agents_not_ready: "Not Ready",
    },
    calls_details_table: {
      calls_count: "{n} call | {n} calls",
      head_callid: "call ID",
      head_mdn: "MDN",
      head_skill: "Queue",
      head_channel: "Channel",
      head_agent: "Agent",
      head_call_type: "Type",
      head_status: "Status",
      head_duration: "Duration",
      head_listen: "Listen",
      head_hangup: "Hangup",
      status_talking: "Talking/{agent}",
      status_waiting: "Waiting",
      call_type_incoming: "Incoming",
      call_type_outgoing: "Outgoing",
      call_type_internal: "Internal",
      listen_btn: "Listen",
      hangup_btn: "Hangup",
      hide_audio_btn: "Close",
      listen_connect: "Connected",
      listen_connecting: "Connecting",
    },
    calls_details_chart: {
      status_talking: "Talking",
      status_waiting: "Waiting",
      call_type_incoming: "Incoming",
      call_type_outgoing: "Outgoing",
      call_type_internal: "Internal",
      title: "{n} call | {n} calls",
      agent: "Agent",
      id: "ID",
      duration_title: "DURATION/sec",
    },
    agents_details_table: {
      agents_count: "{n} agent | {n} agents",
      head_agent: "Agent",
      head_name: "Name",
      head_workPlace: "Work Place",
      head_session: "Session",
      head_skills: "Queues",
      head_status: "Status",
      head_mdn: "MDN",
      head_calltype: "Call Type",
      head_duration: "Duration",
      head_callid: "Call ID",
      head_whisper: "Whisper",
      work_office: "office",
      work_phone: "phone",
      whisper_btn: "Whisper",
      whisper_connect: "Connected",
      whisper_connecting: "Connecting..",
      status_talking: "Talking/{mdn}",
      status_idle: "Idle",
      status_busy: "Not Ready",
      status_rest: "Resting",
      status_offline: "Offline",
      call_talking: "",
      call_waiting: "",
      call_type_incoming: "Incoming",
      call_type_outgoing: "Outgoing",
      call_type_internal: "Internal",
    },
    agents_details_chart: {
      title: "{n} agent | {n} agents",
      status_talking: "Talking",
      status_idle: "Idle",
      status_busy: "Not Ready",
      status_rest: "Resting",
      status_offline: "Offline",
      agent_status: "Status",
      agent_skill: "Queue",
      call_mdn: "MDN",
      session_title: "SESSION/hr",
    },
    on_work: "On Work",
    on_break: "On Break",
    online: "Online",
  },
  ar: {
    title: "مراقبة",
    skill_tab: "مجموعات",
    call_tab: "مكالمات",
    agent_tab: "موظفين",
    skill_select_title: "إختيار مجموعة",
    monitor_btn_start: "بدأ مراقبة",
    monitor_btn_monitor: "جاري المراقبة...",
    details_list: "جدول",
    details_view: "مخطط",
    current_calls: "المكالمات الحالية",
    current_agents: "الموظفين الحاليين",
    current_waiting: "في الانتظار",
    dialog_processing: "المراقبة......",
    max_waiting_time: "آقصى فترة انتظار",
    resting_agents: "في الراحة",
    busy_agents: "غير مستعد",
    no_calls: "لا يوجد مكالمات نشطة",
    all_skills: "الكل",
    main_skills: {
      title: "مكالمات/موظفين المجموعات (مجمّعة)",
      incoming_waiting: "انتظار/واردة",
      incoming_talking: "تحدث/واردة",
      incoming_total: "كل الواردة",
      outgoing_talking: "تحدث/صادرة",
      agents_offline: " موظف غير متصل",
      agents_busy: "موظف غير مستعد",
      agents_rest: "موظف/راحة",
      agents_idle: "موظف متصل",
      agents_talking: "موظف يتحدث",
      agents_total: "كل الموظفين",
      agents_common: "موظف",
      skill: "المجموعة",
      agents_not_ready: "غير مستعد",
    },
    calls_chart: {
      title: "المكالمات",
      calls_total: "كل المكالمات",
      incoming_waiting: "انتظار/واردة",
      incoming_talking: "تحدث/واردة",
      outgoing_talking: "تحدث/صادرة",
    },
    agents_chart: {
      title: "الموظفين",
      agents_total: "كل الموظفين",
      agents_offline: "غير متصل",
      agents_busy: "غير مستعد",
      agents_rest: "راحة",
      agents_idle: "متصل",
      agents_talking: "يتحدث",
      agents_not_ready: "غير مستعد",
    },
    calls_details_table: {
      calls_count:
        "{n} مكالمة | مكالمة واحدة | مكالمتان | {n} مكالمات | {n} مكالمة | {n} مكالمة",
      head_callid: "معرّف المكالمة",
      head_mdn: "رقم الهاتف",
      head_skill: "المجموعات",
      head_channel: "معرف ممر المكالمة",
      head_agent: "الموظف",
      head_call_type: "نوع المكالمة",
      head_status: "الحالة",
      head_duration: "المدة",
      head_listen: "الإستماع",
      head_hangup: "إنهاء المكالمة",
      status_talking: "يتحدث/{agent}",
      status_waiting: "منتظر",
      call_type_incoming: "واردة",
      call_type_outgoing: "صادرة",
      call_type_internal: "داخلية",
      listen_btn: "إستماع",
      hangup_btn: "إنهاء",
      hide_audio_btn: "إغلاق",
      listen_connect: "متصل",
      listen_connecting: "جاري الإتصال",
    },
    calls_details_chart: {
      status_talking: "متحدث",
      status_waiting: "منتظر",
      call_type_incoming: "واردة",
      call_type_outgoing: "صادرة",
      call_type_internal: "داخلية",
      title:
        "{n} مكالمة | مكالمة واحدة | مكالمتان | {n} مكالمات | {n} مكالمة | {n} مكالمة",
      agent: "موظف",
      id: "معرّف",
      duration_title: "المدة(ثواني)",
    },
    agents_details_table: {
      agents_count:
        "لا يوجد | موظف | موظفان | {n} موظفين | {n} موظف | {n} موظف",
      head_agent: "الموظف",
      head_name: "الاسم",
      head_workPlace: "مكان العمل",
      head_session: "الدوام",
      head_skills: "المجموعات",
      head_status: "حالة المكالمة",
      head_mdn: "هاتف العميل",
      head_calltype: "نوع المكالمة",
      head_duration: "مدة المكالمة",
      head_callid: "معرف المكالمة",
      head_whisper: "توجيه",
      work_office: "المكتب",
      work_phone: "هاتف",
      whisper_btn: "توجيه",
      whisper_connect: "متصل",
      whisper_connecting: "جاري الاتصال",
      status_talking: "يتحدث/{mdn}",
      status_idle: "متصل",
      status_busy: "غير مستعد",
      status_rest: "راحة",
      status_offline: "غير متصل",
      call_talking: "محادثة",
      call_waiting: "انتظار",
      call_type_incoming: "واردة",
      call_type_outgoing: "صادرة",
      call_type_internal: "داخلية",
    },
    agents_details_chart: {
      title: "لا يوجد | موظف | موظفان | {n} موظفين | {n} موظف | {n} موظف",
      status_talking: "متحدث",
      status_idle: "متصل",
      status_busy: "غير مستعد",
      status_rest: "راحة",
      status_offline: "غير متصل",
      agent_status: "الحالة",
      agent_skill: "المجموعة",
      call_mdn: "رقم العميل",
      session_title: "الدوام(ساعات)",
    },
    on_work: "في العمل",
    on_break: "في راحة",
    online: "متصلين",
  },
};
